import { z } from "zod";

export const mobileIdSchema = z.string().uuid("ID de móvil inválido");

export const fleetSchema    = z.enum(["kaizen", "transjoven", "cdc"]);
export const workLineSchema = z.enum(["nacional", "internacional", "batea"]);

export const createMobileSchema = z.object({
  workLines:  z.array(workLineSchema).min(1, "Debe tener al menos una línea de trabajo"),
  operatorId: z.string().uuid().nullable().optional(),
  driverId:   z.string().uuid().nullable().optional(),
  truckId:    z.string().uuid().nullable().optional(),
  trailerId:  z.string().uuid().nullable().optional(),
  fleet:      fleetSchema.nullable().optional(),
  notes:      z.string().nullable().optional(),
});

export const updateMobileSchema = createMobileSchema.partial();

export const mobileQuerySchema = z.object({
  deleted: z.enum(["true", "false", "all"]).optional(),
});

export type MobileId     = z.infer<typeof mobileIdSchema>;
export type Fleet        = z.infer<typeof fleetSchema>;
export type WorkLine     = z.infer<typeof workLineSchema>;
export type CreateMobile = z.infer<typeof createMobileSchema>;
export type UpdateMobile = z.infer<typeof updateMobileSchema>;
export type MobileQuery  = z.infer<typeof mobileQuerySchema>;
